import { State } from 'interfaces/state'
import { createSelector } from 'reselect'
import { Home, Car } from 'interfaces/property'
import { getItemsFromCollection, getItemFromCollection } from 'helpers/normalizeHelpers'


const EMPTY_HOMES_ARRAY: Home[] = []
export const homesArraySelector = createSelector(
  (state: State) => state.data.property.homes,
  (homes): Home[] => homes
    ? getItemsFromCollection(homes)
    : EMPTY_HOMES_ARRAY,
)

export const primaryResidenceSelector = createSelector(
  homesArraySelector,
  (homes): Home | null =>
    homes.find((home) => Boolean(home.is_primary_residence)) || null,
)

const EMPTY_CARS_ARRAY: Car[] = []
export const carsArraySelector = createSelector(
  (state: State) => state.data.property.cars,
  (cars): Car[] => cars
    ? getItemsFromCollection(cars)
    : EMPTY_CARS_ARRAY,
)


export const carByIdSelector = createSelector(
  (state: State) => state.data.property.cars,
  (_state: State, params: { carId: number | null }) => params.carId,
  (cars, carId) => {
    if (!cars || carId === null) {
      return null
    }

    return getItemFromCollection(cars, carId)
  }
)
